import StreamingProvider from 'src/components/streaming/StreamingProvider';
import CinemaProvider from 'src/components/streaming/streamingtitlewithproviders/CinemaProvider';
import ICommonDataStructure from "src/components/streaming/streamingtitlewithproviders/CommonDataStructure";
import LeftArrowSvg from 'src/components/svg/LeftArrowSvg';
import RightArrowSvg from 'src/components/svg/RightArrowSvg';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './ProviderScroller.module.css';

//#region [Props]
type ProviderScrollerProps = {
	data: ICommonDataStructure;
	isCinemaRelevant?: boolean;
	useCinemaRelevantProp?: boolean;
	className?: string;
};
//#endregion

//#region [Component]
export default function ProviderScroller({ data, isCinemaRelevant = false, useCinemaRelevantProp = false, className }: ProviderScrollerProps) {
	const scrollContainer = useRef<HTMLDivElement>(null);
	const [disabledStates, setDisabledStates] = useState([true, false]);

	useEffect(() => {
		const curr = scrollContainer.current!;
		let timer: ReturnType<typeof setTimeout> | null = null;
		const listener = (e: Event) => {
			if (timer) {
				clearTimeout(timer);
				timer = null;
			}
			timer = setTimeout(() => {
				// console.debug("SCROLL", curr.scrollLeft, curr.clientWidth, curr.scrollWidth, curr.scrollLeft + curr.clientWidth);
				// must use Math.round because sometime subixel presicion
				if (Math.round(curr.scrollLeft + curr.clientWidth) >= curr.scrollWidth) {
					setDisabledStates([false, true]);
				} else if (curr.scrollLeft === 0) {
					setDisabledStates([true, false]);
				} else {
					setDisabledStates([false, false]);
				}

			}, 200);

		};
		curr.addEventListener("scroll", listener);
		return () => {
			if (timer) {
				clearTimeout(timer);
			}
			if (curr) {
				curr.removeEventListener("scroll", listener);
			}

		}
	}, []);

	const showCinemaProvider = useCinemaRelevantProp ? isCinemaRelevant ?? data.isCinemaRelevant : data.isCinemaRelevant;

	const providerContents = data.providerContents;

	return <div className={classNames(styles.SProviderScrollerContainer, className)}>
		{(providerContents?.length ?? 0) > 2 && <button className={styles.SScrollerButton} disabled={disabledStates[0]} onClick={() => clickLeft(scrollContainer.current)}><LeftArrowSvg className={styles.SLeftArrowSvg} /></button>}
		<div className={styles.SProviderList} ref={scrollContainer}>
			{showCinemaProvider && !!data.filmwebMovieId &&
				<CinemaProvider className={styles.SCinemaProvider} movieId={data.filmwebMovieId} premiere={data.premiereCinema} hasCinemaShows={data.hasCinemaShows} />}
			{providerContents?.map(pc => <StreamingProvider className={styles.SStreamingProvider} key={pc?.id} providerContent={pc!} />)}
		</div>
		{(providerContents?.length ?? 0) > 2 && <button className={styles.SScrollerButton} disabled={disabledStates[1]} onClick={() => clickRight(scrollContainer.current)}><RightArrowSvg className={styles.SRightArrowSvg} /></button>}
	</div>;
}
//#endregion

function clickRight(ref: HTMLDivElement | null) {
	ref?.scrollBy(ref?.getElementsByTagName('a')[2].offsetLeft, 0);
}

function clickLeft(ref: HTMLDivElement | null) {
	ref?.scrollBy(-1 * ref?.getElementsByTagName('a')[2].offsetLeft, 0);
}

